module.exports = __webpack_public_path__ + "media/images/emblems/Thalwil-blazon-91ffed6edd09a82d08e87e22f5588839.svg";